import React from "react";

const InboxIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.7799 19.73H17.5699C17.3601 19.73 17.1899 19.9001 17.1899 20.11V21.03C17.1899 21.2398 17.3601 21.41 17.5699 21.41H21.7799C21.9898 21.41 22.1599 21.2398 22.1599 21.03V20.11C22.1599 19.9001 21.9898 19.73 21.7799 19.73Z"
        fill="#57CC99"
      />
      <path d="M23.2101 14.77C23.2101 14.03 22.6101 13.42 21.8701 13.4C21.2501 13.38 20.6401 13.56 20.1001 13.91L16.9201 16C16.3301 16.39 15.5601 16.39 14.9601 16L11.7801 13.91C11.2401 13.56 10.6301 13.38 10.0101 13.4C9.27013 13.42 8.67013 14.03 8.67013 14.77L8.42013 13.41C8.26013 12.58 8.90013 11.8 9.75013 11.8H22.1201C22.9701 11.8 23.6101 12.57 23.4501 13.41L23.2001 14.77H23.2101Z" />
      <path d="M22.08 12.5701C22.7 12.5701 23.21 13.0801 23.21 13.7001V21.2601C23.21 21.8801 22.7 22.3901 22.08 22.3901H9.83C9.21 22.3901 8.7 21.8801 8.7 21.2601V13.7001C8.7 13.0801 9.21 12.5701 9.83 12.5701H22.08ZM22.08 11.3701H9.83C8.54 11.3701 7.5 12.4201 7.5 13.7001V21.2601C7.5 22.5501 8.54 23.5901 9.83 23.5901H22.08C23.37 23.5901 24.41 22.5501 24.41 21.2601V13.7001C24.41 12.4201 23.37 11.3701 22.08 11.3701Z" />
      <path d="M23.41 11.79H8.5L14.93 7.31998C15.54 6.89998 16.35 6.88998 16.96 7.31998L23.4 11.79H23.41Z" />
    </svg>
  );
};

export default InboxIcon;
